
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { TextBlock } from "@/utils/label-layout/text-block";
import {  Model } from "@/utils/models/model";
import Vue from "vue";
import AppTextBlockSettings from "./TextBlockSettings.vue";

export default Vue.extend({
	data(){
		return {
			toEditBlockIndex: -1
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		model():Model{
			return this.layout.getModel();
		},
		toEditBlock():TextBlock | null {
			return this.layout.TextBlocks[this.toEditBlockIndex] || null;
		}
	},
	methods: {
		addNewBlock(){
			let block = new TextBlock();
			this.layout.TextBlocks.push(block);
			this.toEditBlockIndex = this.layout.TextBlocks.length-1;
		},
		deleteBlock(i:number){
			this.layout.TextBlocks.splice(i,1);
			if (this.toEditBlockIndex == i) {
				this.toEditBlockIndex = -1;
			} else if (this.toEditBlockIndex > i) {
				this.toEditBlockIndex--;
			}
		},
		editBlock(block:TextBlock){
			this.toEditBlockIndex = this.layout.TextBlocks.indexOf(block);
		}
	},
	components: {
		AppTextBlockSettings
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
